export default __webpack_public_path__ + "static/media/i3.dfd06afe.png";